import {Person, Profile, StyledBaseProps} from "@betrue/shared/interfaces";
import styled from "styled-components";
import {ProfileCompletionProps} from "./profile-completion";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ErrorIcon from '@material-ui/icons/Error';
import DoneIcon from '@material-ui/icons/Done';

interface ProfileCompletionViewProps extends StyledBaseProps, ProfileCompletionProps {
  profile: Profile
  person: Person
}

export const ProfileCompletionView = styled((props: ProfileCompletionViewProps) => (
  <div className={props.className}>
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
    >
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="flex-start"
      >
        <Accordion defaultExpanded={props.profile.completion < 100}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon/>}
            aria-controls="panel1a-content"
          >
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center">
              <Grid item className={'bt-completion-circle'}>
                <Box position="relative" display="inline-flex">
                  <CircularProgress size={50}
                                    variant={'determinate'}
                                    className={'bt-circle'}
                                    value={props.profile.completion}/>
                  <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography variant="caption" style={{fontSize: '14px', fontWeight: 'bold'}} component="div"
                                color="textSecondary">{`${Math.round(
                      props.profile.completion,
                    )}%`}</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
              >
                <Typography variant={'h6'}>{props.title}</Typography>
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <List disablePadding={true}>
              <ListItem>
                <ListItemIcon>
                  {props.profile.job ? (<DoneIcon className={'bt-done'}/>) : (<ErrorIcon className={'bt-warning'}/>)}
                </ListItemIcon>
                <ListItemText
                  primary={props.jobLabel}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  {props.person.hasAvatar ? (<DoneIcon className={'bt-done'}/>) : (<ErrorIcon className={'bt-warning'}/>)}
                </ListItemIcon>
                <ListItemText
                  primary={props.avatarLabel ? props.avatarLabel : 'Ajouter une photo de profil'}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  {props.person.firstName ? (<DoneIcon className={'bt-done'}/>) : (
                    <ErrorIcon className={'bt-warning'}/>)}
                </ListItemIcon>
                <ListItemText
                  primary={props.firstnameLabel}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  {props.profile.skills?.length > 4 ? (<DoneIcon className={'bt-done'}/>) : (
                    <ErrorIcon className={'bt-warning'}/>)}
                </ListItemIcon>
                <ListItemText
                  primary={props.skillsLabel}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  {props.profile.available ? (<DoneIcon className={'bt-done'}/>) : (
                    <ErrorIcon className={'bt-warning'}/>)}
                </ListItemIcon>
                <ListItemText
                  primary={props.availableLabel}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  {props.profile.price ? (<DoneIcon className={'bt-done'}/>) : (<ErrorIcon className={'bt-warning'}/>)}
                </ListItemIcon>
                <ListItemText
                  primary={props.priceLabel}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  {props.profile.description ? (<DoneIcon className={'bt-done'}/>) : (
                    <ErrorIcon className={'bt-warning'}/>)}
                </ListItemIcon>
                <ListItemText
                  primary={props.descriptionLabel}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  {props.person.chatId ? (<DoneIcon className={'bt-done'}/>) : (
                    <ErrorIcon className={'bt-warning'}/>)}
                </ListItemIcon>
                <ListItemText
                  primary={props.chatLabel ? props.chatLabel : 'Connexion au chat'}
                />
              </ListItem>
            </List>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  </div>
))`
  width: 100%;

  & .bt-warning {
    color: ${props => props.theme.colors.warning}
  }

  & .bt-done {
    color: ${props => props.theme.colors.success}
  }

  & .bt-circle {
    color: ${props => props.profile.completion === 100 ? props.theme.colors.success : props.theme.colors.warning}
  }

  & .bt-success {

  }

  & .bt-completion-circle {

    margin: 10px;
  }
`
